import React, { useMemo } from 'react';
import Bug from '@atlaskit/icon-object/glyph/bug/16';
import Story16Icon from '@atlaskit/icon-object/glyph/story/16';
import { highlightSearchTerm } from '../../utils/highlight-search-result-keyword';

export enum TicketType {
    BUG = 'bug',
    SUGGESTION = 'suggestion'
}

interface TitleSectionProps {
    ticketType?: TicketType;
    title: string;
    searchTerm: string;
}

export const TitleSection: React.FC<TitleSectionProps> = ({
    ticketType,
    title,
    searchTerm
}: TitleSectionProps) => {
    const StoryType = useMemo(() => {
        if (ticketType === TicketType.BUG) {
            return <Bug label="Bug" />;
        } else if (ticketType === TicketType.SUGGESTION) {
            return <Story16Icon label="Suggestion" />;
        }
    }, [ticketType]);

    return (
        <div className="title-section">
            {ticketType !== undefined && (
                <div className="card-type" data-testid="ticket-type">
                    {StoryType}
                    <span className="label font-weight-400">
                        {ticketType === TicketType.BUG ? 'Bug' : 'Suggestion'}
                    </span>
                </div>
            )}
            <h3
                className="card-title font-weight-600 text-gray"
                data-testid="title"
            >
                {highlightSearchTerm(searchTerm, title)}
            </h3>
        </div>
    );
};
